import React from 'react'
import { Form } from 'react-bootstrap'

const InputIcon = ({ type, placeholder, icon, handleChange, value }) => {
    return (
        <Form>

            {
                !icon && (
                    <Form.Group className="mb-3 ">
                        <Form.Control onChange={handleChange} type={type} value={value} className="bg-light border-0" placeholder={placeholder} />
                    </Form.Group>

                )
            }

            {
                icon && (
                    <>
                        <Form.Group className="mb-3 bg-light rounded-3 align-items-center row">
                            <div className="col">
                                <Form.Control onChange={handleChange} value={value} type={type} className="bg-transparent border-0" placeholder={placeholder} />
                            </div>

                            <div className="col-auto px-4">
                                {icon && <span className="text-muted">{icon}</span>}
                            </div>
                        </Form.Group>
                    </>
                )
            }
        </Form>
    )
}

export default InputIcon